import {
  DATA_AVAILABLE,
  FINISH_LOADING_APPLICATION,
  RLTD_ACC_NOT_AVL,
  SET_DEALER_ACCOUNT_DETAILS,
  SET_PARENT_DEALER_ACCOUNT_ID,
  SET_TRANSACTION_COUNT,
  START_LOADING_APPLICATION,
} from "../action";
import { getDealerAccountDetails, getTxnsForReviewCount } from "../api/api.js";
import { TXN_STATUS } from "../utilities/constants.js";

export const fetchRelatedAccounts =
  (userData, isLoading = false) =>
  async (dispatch) => {
    if (isLoading) {
      dispatch({ type: START_LOADING_APPLICATION });
      try {
        const data = await getDealerAccountDetails(userData?.dealerAccountId);
        if (data) {
          dispatch({
            type: SET_DEALER_ACCOUNT_DETAILS,
            payload: data,
          });
          dispatch({type: DATA_AVAILABLE});
        getTxnsForReviewCountAPi(userData, data?.group3LeadId, dispatch);
        return data;
        }else{
          dispatch({type: RLTD_ACC_NOT_AVL});
          dispatch({ type: FINISH_LOADING_APPLICATION });
        }
      } catch (error) {
        dispatch({ type: RLTD_ACC_NOT_AVL });
        dispatch({ type: FINISH_LOADING_APPLICATION });
        console.error("Error fetching related accounts:", error);
      } finally {
        dispatch({ type: FINISH_LOADING_APPLICATION });
      }
    } else {
      try {
        const data = await getDealerAccountDetails(userData?.dealerAccountId);
        if (data !== undefined) {
          dispatch({type: SET_DEALER_ACCOUNT_DETAILS, payload: data});
          dispatch({type: DATA_AVAILABLE});
          return data;
        }else{
          dispatch({type: RLTD_ACC_NOT_AVL});
          dispatch({ type: FINISH_LOADING_APPLICATION });
        }
      } catch (error) {
        dispatch({ type: RLTD_ACC_NOT_AVL });
        dispatch({ type: FINISH_LOADING_APPLICATION });
        console.error("Error fetching related accounts:", error);
      } finally {
        dispatch({ type: FINISH_LOADING_APPLICATION });
      }
    }
  };

const getTxnsForReviewCountAPi = (
  userData,
  parentDealerAccountId,
  dispatch
) => {
  getTxnsForReviewCount({
    dealerAccountId: userData?.dealerAccountId,
    parentDealerAccountId: parentDealerAccountId,
    txnStatus: TXN_STATUS.SUBMITTED,
  })
    .then((countData) => {
      dispatch({ type: SET_TRANSACTION_COUNT, payload: countData });
    })
    .catch((error) => {
      console.error("Error fetching transaction count:", error);
    });
};

export const setParentDealerAccountDetailsAtTxn = (group3LeadId) => {
  return (dispatch) => {
    dispatch({
      type: SET_PARENT_DEALER_ACCOUNT_ID,
      payload: {
        textKey: "parentDealerAccountID",
        textValue: group3LeadId,
      },
    });
  };
};
